import { Button, Grid, Input, Slider, Space, Toast } from "antd-mobile"
import { useCallback, useState } from "react"
import { useNavigate } from "react-router-dom"
import { SearchOutline } from "antd-mobile-icons"
import { searchProduct } from "../../api/getData"
import { DATA_TYPE, getData, setData } from "../../api/userData"

function Ate() {
  const [search, setSearch] = useState("")
  const [name, setName] = useState("")
  const [showWeight, setShowWeight] = useState(false)
  const [weight, setWeight] = useState(200)
  const [searchResult, setSearchResult] = useState([])
  const navigate = useNavigate()

  const onClick = useCallback(
    (path) => {
      navigate(path)
    },
    [navigate]
  )

  const openNotification = () => {
    Toast.show({
      content: "Добавлено",
      position: "bottom",
    })
  }

  const onItemClick = useCallback((name) => {
    setName(name)
    setWeight(200)
    setShowWeight(true)
  }, [])

  const onAdd = useCallback(() => {
    const data = { value: getData(DATA_TYPE.DIET)?.value || [] }

    data.value = [
      ...data.value,
      {
        name,
        createdAt: new Date().toLocaleDateString(),
        id: data.value.length,
        weight,
      },
    ]

    setData(DATA_TYPE.DIET, data)
    openNotification()
    setShowWeight(false)
  }, [weight, name])

  const onChangeWeight = useCallback((value) => {
    setWeight(value)
  }, [])

  const onChange = useCallback((value) => {
    setSearch(value)
  }, [])

  const onSearch = useCallback(() => {
    if (search === "") {
      setSearchResult([])
    } else {
      const result = searchProduct(search)
      console.log("result", result)

      setSearchResult(result)
    }
  }, [search])

  const onClear = useCallback(() => {
    setSearchResult([])
    setSearch("")
  }, [])

  return (
    <>
      <Grid
        columns={12}
        gap={12}
        style={{
          marginLeft: 16,
          marginRight: 16,
          width: "100%",
          height: "calc(100vh - 120px)",
        }}
      >
        <Grid.Item span={12}>
          <div style={{ display: "flex", direction: "row" }}>
            <Input
              onChange={onChange}
              onClear={onClear}
              placeholder="Напишите, что вы съели"
              clearable
              style={{
                border: "1px solid #d2d2d2",
                padding: 6,
                marginRight: 16,
              }}
            />
            <Button
              color="success"
              fill="outline"
              size="large"
              onClick={() => onSearch()}
            >
              <Space>
                <SearchOutline />
                <span>Найти</span>
              </Space>
            </Button>
          </div>
        </Grid.Item>
        <Grid.Item
          span={12}
          style={{
            height: "calc(100vh - 300px)",
            overflowY: "auto",
            overflowX: "none",
          }}
        >
          {!showWeight && searchResult.length === 0 && (
            <div style={{ display: "flex", height: "calc(100vh - 300px)" }}>
              <p style={{ margin: "auto", padding: 40, textAlign: "center" }}>
                Проверяйте окончание. Например, вместо "вареный" или "вареное",
                допускается поиск по короткому "вар"
              </p>
            </div>
          )}
          {!showWeight &&
            searchResult.map((item, index) => {
              const [name, cal, fat, prot, carb] = String(item).split("|")
              return (
                <div
                  key={`list-${index}`}
                  style={{ paddingTop: 10, paddingBottom: 10 }}
                  onClick={() => onItemClick(item)}
                >
                  <div style={{ fontSize: 16 }}>{name}</div>
                  <div style={{ fontSize: 14 }}>
                    {cal} ккал, ЖБУ ({fat}, {prot} , {carb})
                  </div>
                </div>
              )
            })}
          {showWeight && (
            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  paddingTop: 16,
                }}
              >
                <p
                  style={{
                    width: "50%",
                    textAlign: "right",
                    paddingRight: 16,
                  }}
                >
                  Вес порции:
                </p>
                <p>{weight} г.</p>
              </div>
              <div style={{ paddingLeft: 4, paddingRight: 4 }}>
                <Slider
                  step={10}
                  defaultValue={200}
                  min={10}
                  max={900}
                  onChange={(value) => onChangeWeight(parseInt(value))}
                />
              </div>
              <div style={{ height: 30 }} />
              <Button
                block
                color="success"
                fill="outline"
                size="large"
                onClick={onAdd}
              >
                Добавить
              </Button>
            </div>
          )}
        </Grid.Item>
        <Grid.Item span={12}>
          <Button
            block
            color="success"
            fill="outline"
            size="large"
            onClick={() => onClick("/myDiet")}
          >
            Мой рацион
          </Button>
        </Grid.Item>
        <Grid.Item span={12}>
          <Button
            block
            color="success"
            fill="outline"
            size="large"
            onClick={() => onClick("/addNewProduct")}
          >
            Добавить новый продукт
          </Button>
        </Grid.Item>
      </Grid>
    </>
  )
}

export default Ate
